import { useState } from "react";
import { DatePicker, Divider, H6 } from "orcs-design-system";
import moment from "moment";
import { EVENT_TRACKING } from "src/consts/eventTracking";
import { trackEvent } from "src/services/segment";
import type { DateSettings } from "src/app/apolloClient";
import { isBeforeDay } from "./isBeforeDay";

type SingleDatePickerProps = {
  dateSettings: DateSettings;
  setDateSettings: (changes: Partial<DateSettings>) => void;
  dateFormats: { short: string };
  oldestPersonIndexDateMoment: moment.Moment;
};

const SingleDatePicker = ({
  dateSettings,
  setDateSettings,
  dateFormats,
  oldestPersonIndexDateMoment,
}: SingleDatePickerProps) => {
  const [focused, setFocused] = useState(false);

  return (
    <>
      <Divider light />
      <H6 weight="bold">View data on</H6>
      <DatePicker
        single
        id="historic-date-picker"
        focused={focused}
        date={dateSettings.toDate || moment()}
        onDateChange={(toDate) => {
          setDateSettings({ toDate });
          trackEvent(EVENT_TRACKING.SETTING_CHANGED, {
            setting: "historical_date",
            value: "single_date",
          });
        }}
        onFocusChange={({ focused: nextFocused }) => {
          setFocused(nextFocused);
        }}
        numberOfMonths={1}
        daySize={31}
        displayFormat={dateFormats.short}
        isOutsideRange={(day) => isBeforeDay(day, oldestPersonIndexDateMoment)}
      />
    </>
  );
};

export default SingleDatePicker;
